// src/pages/hotels/index.js

import HotelsPage from "../../components/hotels/HotelsPage";

export default function Hotels() {
  return <HotelsPage />;
}
